import { Accordion, Box, Divider, Stack, Text } from '@stitch-fix/mode-react';

export const LandingFaqModule = (props: {
  content: { description: string; headline: string }[];
  headline: string;
  isMobile: boolean;
}) => {
  const { content, headline, isMobile } = props;

  return (
    <Box px={isMobile ? 1 : 3.5} py={2}>
      <Text setting="title-large" align="center" color="blue-45" mb={2.5}>
        {headline}
      </Text>
      <Stack>
        {content.map(
          (item: { description: string; headline: string }, idx: number) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div key={idx}>
                {idx > 0 && <Divider variant="statement" my={1} />}
                <Accordion
                  heading={item.headline}
                  headingLevel="h2"
                  color="navy"
                  expandIconAlignment="fixed-end"
                >
                  <Text setting="body-large" color="blue-45">
                    {item.description}
                  </Text>
                </Accordion>
              </div>
            );
          },
        )}
      </Stack>
    </Box>
  );
};
